<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
const MODE = import.meta.env.MODE
</script>

<template>
  <div class="build-info">
    <!-- TODO: pull from env or smth, requires tweaking dockerfiles -->
    <div>Version 0.0.0 1de61e6ad ({{ MODE }})</div>
    <div>Built on June 19, 2024</div>
  </div>
</template>

<style scoped>
.build-info {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
</style>
